import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { FunctionsState, RootState } from './functions-types';

export const state: FunctionsState = {
  functions: undefined,
  error: false,
};

const namespaced = true;

export const functions: Module<FunctionsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
